import { useContext, useEffect, useState } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Box, Typography } from '@mui/material'
import NodeItem from '../NodeItem/index'
import { PlaybookContext } from '../../../../contexts/playbooks.context'

import styles from './styles.module.scss'
import Search from '../../../shared/Search'

const DragAndDrop = () => {
  const { nodeTypes } = useContext(PlaybookContext)
  const [searchValue, setSearchValue] = useState('')
  const [filteredNodeTypes, setFilteredNodeTypes] = useState(nodeTypes)

  useEffect(() => {
    setFilteredNodeTypes(
      nodeTypes.filter(({ name }) =>
        name.toLowerCase().includes(searchValue.toLocaleLowerCase()),
      ),
    )
  }, [nodeTypes, searchValue])

  return (
    <Box padding="20px">
      <Search onSearch={setSearchValue} label="Search Nodes" fullWidth />
      <Typography className={styles.nodesTitle}>New Nodes Drag&Drop</Typography>
      <DndProvider backend={HTML5Backend}>
        <Box className={styles.dragNDrop}>
          {filteredNodeTypes.map((newNode) => {
            return (
              <NodeItem
                key={newNode.slug}
                name={newNode.name}
                type={newNode.slug}
                description={newNode.description}
                icon={newNode.icon}
              />
            )
          })}
        </Box>
      </DndProvider>
    </Box>
  )
}

export default DragAndDrop
